import type { RootState } from "@/store";

export const selectPersonas = (state: RootState) => state.app.personas;
export const selectIsLoading = (state: RootState) => state.app.isLoading;
export const selectError = (state: RootState) => state.app.error;
export const selectCurrentPersona = (state: RootState) => state.app.currentPersona;
